module.exports = __webpack_public_path__ + "static/img/qrcode.989123c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/qrcode.jpg
// module id = Hjk3
// module chunks = 50